export const LOAD_PARTNER_CONSENTS_SUCCEEDED = "LOAD_PARTNER_CONSENTS_SUCCEEDED";
